import { Reducer } from 'redux';
import { EstoqueCartState, EstoqueCartTypes } from "./types";

const INITIAL_STATE: EstoqueCartState = {
  cart: [],
  data: [],
  error: false,
  loading: false,
  loadingLote: false,
  endereco: []
}

const reducer: Reducer<EstoqueCartState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case EstoqueCartTypes.ADD_ITEM_REQUEST:
      return {
        ...state,
        cart: action.payload.item,
      };
    case EstoqueCartTypes.DELETE_ITEM_REQUEST:
      return {
        ...state,
        cart: action.payload.data,
      };
      case EstoqueCartTypes.PAGADORES_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case EstoqueCartTypes.PAGADORES_SUCCESS:
        return {
          ...state,
          loading: false,
          error: false,
          data: action.payload.data,
        };
      case EstoqueCartTypes.PAGADORES_FAILURE:
        return {
          ...state,
          loading: false,
          error: true,
          data: [],
        };
      
        case EstoqueCartTypes.ENDERECO:
        return {
          ...state,
          endereco: action.payload.endereco,
        };

        case EstoqueCartTypes.CLEAR_END:
        return {
          ...state,
          endereco: [],
        };

      case EstoqueCartTypes.CLEAR_CART:
        return INITIAL_STATE
    
    default:
      return state;
  }
  
};

export default reducer;